import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * On every route change, scroll the window to the top.
 * Without this, navigating between long pages keeps the previous scroll
 * position which is jarring on a marketing site.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) return // let in-page anchors work
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' })
  }, [pathname, hash])

  return null
}

export default ScrollToTop
